// reference: https://theplanttokyo.atlassian.net/browse/VHM-1449?focusedCommentId=360845
// enquiry form / book visit form / corporate enquiry form / auto debit form / application form / cancellation form
export const telephone = /^(070|080|090|050|020|060)\d{8}$|^\d{10}$/;
